/**
 * Centralised dev-only logger.
 * In production builds (`NODE_ENV !== 'development'`) the calls are no-ops
 * so we get a clean console while still surfacing supplementary fetch
 * failures during local development.
 */
const isDev = process.env.NODE_ENV === 'development';

export const devWarn = (...args) => {
  if (isDev) console.warn(...args);
};

export const devError = (...args) => {
  if (isDev) console.error(...args);
};
